export enum SuggestionUserResolution {
  RESOLVED = 'RESOLVED',
  DISMISSED = 'DISMISSED',
}

export enum SuggestionUserResolutionFilter {
  RESOLVED = 'RESOLVED',
  DISMISSED = 'DISMISSED',
  WITHOUT_RESOLUTION = 'WITHOUT_RESOLUTION',
}
